export interface OnboardingPayload {
  email: string;
  password: string;
  role?: "creator" | "brand" | "";
  advertiser_type?: "agency" | "brand" | "";
  agency_name?: string;
  phone?: string;
  phone_prefix?: string;
  ig_username?: string;
  tiktok_username?: string;
  selectedLanguage?: string;
}

export default {
  namespaced: true,
  state: (): OnboardingPayload => ({
    email: "",
    password: "",
    phone: "",
    phone_prefix: "216",
    ig_username: "",
    tiktok_username: "",
    selectedLanguage: "",
    role: "",
    advertiser_type: "",
    agency_name: "",
  }),
  mutations: {
    SET_BASE_CREDENTIALS(state: any, payload: any) {
      state.email = payload.email;
      state.password = payload.password;
      state.selectedLanguage = payload.selectedLanguage;
      state.role = payload.role;
    },
    SET_PHONE(state: any, payload: any) {
      state.phone = payload.phone;
      state.phone_prefix = payload.phone_prefix;
    },
    SET_SOCIALS(state: any, payload: any) {
      state.ig_username = payload.ig_username;
      state.tiktok_username = payload.tiktok_username;
    },
    RESET(state: any) {
      Object.assign(state, {
        email: "",
        password: "",
        phone: "",
        phone_prefix: "216",
        ig_username: "",
        tiktok_username: "",
        selectedLanguage: "",
      });
    },
  },
};
